export enum PaymentMethod {
    BLIK_ONLINE = 'BLIK_ONLINE',
    BLIK = 'BLIK',
    ONLINE_TRANSFER = 'ONLINE_TRANSFER',
    CARD = 'CARD',
    STANDARD_TRANSFER = 'STANDARD_TRANSFER',
    MPAY = 'MPAY',
    SKYCASH = 'SKYCASH',
    TAP_ON_MOBILE = 'TAP_ON_MOBILE',
    APPLE_PAY = 'APPLE_PAY',
    GOOGLE_PAY = 'GOOGLE_PAY',
    NESTBANK = 'NESTBANK',
}
